import * as globalVariable from '../core/globalVariable';

const permission = globalVariable.Admin;

const home = {
    text: 'Home',
    link: '/home',
    icon: 'icon-home',
    permission: permission
};

const report = {
    text: 'Report',
    link: '/report',
    icon: 'icon-grid',
    permission: permission
};

export const menu = [
    home,
    report
];
